import { useCallback } from 'react';

export default function Hero() {
  const scrollTo = useCallback((href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  }, []);

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center pt-[72px] pb-16 md:pb-20 overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-primary-50/30"></div>
      <div className="absolute top-20 right-0 w-[600px] h-[600px] rounded-full bg-primary-100/30 blur-3xl pointer-events-none"></div>
      <div className="absolute bottom-10 left-10 w-[400px] h-[400px] rounded-full bg-accent-100/20 blur-3xl pointer-events-none"></div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-xs md:text-sm font-medium mb-6">
              <i className="ri-fire-line text-sm"></i>
              <span>每日更新 · 万部漫画在线</span>
            </div>

            <h1 className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl text-foreground-950 leading-tight mb-4">
              谜妹漫画
              <span className="block text-primary-500">韩漫日漫国漫分类大全</span>
            </h1>

            <p className="text-lg md:text-xl text-foreground-600 font-medium mb-4">
              悬疑烧脑 · 恋爱甜宠 · 爆笑日常，每一种口味都值得被满足
            </p>

            <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto lg:mx-0 leading-relaxed mb-8">
              谜妹漫画汇集海量韩漫、日漫与国漫资源，覆盖悬疑漫画、恋爱漫画、搞笑漫画等全类型分类。
              采用下拉式流畅阅读体验，无需跳转、无需等待，翻页顺滑如纸。每日同步更新热门连载，
              无论是追更党还是补番党，都能在这里找到属于自己的漫画世界。当前站内已收录超过
              30000 部作品，涵盖 20 余个细分品类，韩漫区本月新增 200+ 部人气新作。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-primary-500">30000+</div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">收录漫画</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-500">20+</div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">细分品类</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-primary-500">每日更新</div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">同步连载</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <button
                onClick={() => scrollTo('#carousel')}
                className="w-full sm:w-auto px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-full transition-colors whitespace-nowrap cursor-pointer text-sm md:text-base"
              >
                开始阅读
                <i className="ri-arrow-right-line ml-2"></i>
              </button>
              <button
                onClick={() => scrollTo('#ranking')}
                className="w-full sm:w-auto px-8 py-3 border border-background-300 hover:border-primary-300 hover:text-primary-500 text-foreground-700 font-medium rounded-full transition-colors whitespace-nowrap cursor-pointer text-sm md:text-base"
              >
                人气排行
                <i className="ri-fire-line ml-2"></i>
              </button>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-[280px] h-[380px] md:w-[380px] md:h-[520px] lg:w-[440px] lg:h-[580px] rounded-2xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20artistic%20illustration%20of%20cozy%20manga%20reading%20scene%20with%20floating%20colorful%20comic%20pages%20and%20speech%20bubbles%2C%20soft%20coral%20and%20cream%20tones%2C%20dreamy%20atmosphere%2C%20stylized%20flat%20illustration%20with%20gentle%20textures%2C%20a%20person%20sitting%20comfortably%20reading%20on%20a%20cozy%20couch%20near%20window%20with%20warm%20sunlight%2C%20bookshelves%20in%20background%2C%20delicate%20linework%2C%20no%20text%20no%20letters%2C%20peaceful%20mood%2C%20editorial%20illustration%20style%20with%20soft%20gradients%2C%20pastel%20warm%20color%20palette&width=880&height=1160&seq=manga-hero-main&orientation=portrait"
                alt="谜妹漫画 - 韩漫日漫国漫免费在线阅读"
                title="谜妹漫画 - 韩漫日漫国漫分类大全"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/10 to-transparent pointer-events-none"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}